"use strict";
const REGISTRY_RESULT_FOUND = "NALEZEN";
const REGISTRY_RESULT_NOT_FOUND = "NENALEZEN";
const REGISTRY_RESULT_NOT_SEARCHED = "NEDOTAZAN";
const REGISTRY_RESULT_ERROR = "CHYBA";
const REGISTRY_RESULT_OK = "OK";
const REGISTRY_RESULT_IN_PROGRESS = "ZPRACOVAVA";

let RegistryDataParser = class {
	
//public:
	
	/**
	 * Constructor
	 * @param data
	 */
	constructor (data) {
		this._data = data;
		this._html = "";
		//this._crvExists = false;
	}
	
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	/**
	 * Print data into HTML formatted string
	 * @returns {string}
	 */
	getHtml () {
		this._html = "";
		if ('patrosResponse' in this._data) {
			this.formatPatrani(this._data.patrosResponse, true);
		}
		if ('patrmvResponse' in this._data) {
			this.formatPatrani(this._data.patrmvResponse, false);
		}
		
		if ('crvResponse' in this._data) {
			this.formatCRVResponse(this._data.crvResponse);
		}

		if ('eucarisResponse' in this._data) {
			this.formatEucarisResponse(this._data.eucarisResponse);
		}

		if ('robResponse' in this._data) {
			this.formatRobResponse(this._data.robResponse);
		}

		if ('eopResponse' in this._data) {
			this.formatEopResponse(this._data.eopResponse);
		}

		if ('rosResponse' in this._data) {
			this.formatRosResponse(this._data.rosResponse);
		}

		if ('crrResponse' in this._data) {
			this.formatCrrResponse(this._data.crrResponse);
		}

		if ('aiseoResponse' in this._data) {
			this.formatAiseoResponse(this._data.aiseoResponse);
		}

		if ('aiscResponse' in this._data) {
			this.formatAiscResponse(this._data.aiscResponse);
		}

		if ('isepInsertResponse' in this._data) {
			this.formatIsepInsertResponse(this._data.isepInsertResponse);
		}

		if ('isepDeleteResponse' in this._data) {
			this.formatIsepDeleteResponse(this._data.isepDeleteResponse);
		}
		
		if ('isepSelectResponse' in this._data) {
			this.formatIsepReadResponse(this._data.isepSelectResponse);
		}

		if ('isrtResponse' in this._data) {
			this.formatIsrtResponse(this._data.isrtResponse);
		}

		if ('logResponse' in this._data) {
			this.formatLogResponse(this._data);
		}
		
		if (!this._html)
		{
			this._html = "<div class='alert alert-danger' role='alert'>";
			if ('message' in this._data) {
				this._html += this._data.message;
			} else {
				this._html += "Invalid data";
			}
			this._html += "</div>";
		}

		return this._html;
	}

	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------
	
	static formatRequest (requestData) {
		var html = "<h3>" + RegistryDataParser.transKey('requestHeader') + "</h3>"
			+ "<table><thead><tr><th>Jebat</th><th>cecky</th></tr>"
			+ "</thead></table>";
		return html;
	}
	
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

//=============================================================================
	
//private:

	//-------------------------------------------------------------------------
	// Value formatting methods
	//-------------------------------------------------------------------------

	/**
	 * Try to translate given key
	 * @param key
	 * @returns {*}
	 */
	static transKey (key) {
		if (key in $Lang.registry.dataParserKeys)
		{
			return $Lang.registry.dataParserKeys[key];
		}
		return key;
	}
	
	/**
	 * Transform mysql date to human format
	 * @param dateStr
	 * @returns {string|*}
	 */
	static formatDate (dateStr) {
		if (dateStr) {
			const re2 = /(\d{4})-(\d{1,2})-(\d{1,2})[T\s+](\d{1,2}):(\d{1,2}):(\d{1,2}).*/,
				matches2 = dateStr.match(re2);
			if (matches2) {
				return parseInt(matches2[3]) + "." + parseInt(matches2[2]) + "." + matches2[1] + " " + matches2[4] + ":" + matches2[5] + ":" + matches2[6];
			}
			const re = /(\d{4})-(\d{1,2})-(\d{1,2})/,
				matches = dateStr.match(re);
			if (matches) {
				return parseInt(matches[3]) + "." + parseInt(matches[2]) + "." + matches[1];
			}
			return dateStr;
		}
		return "";
	}
	
	/**
	 * Transform mysql date to human format
	 * @param addressData
	 * @returns {string|*}
	 */
	static formatAddress (addressData) {
		var address = "";
		if (addressData) {
			if (addressData.id || addressData.ulice || addressData.mesto || addressData.smerovaciCislo) {
				address += addressData.ulice + " ";
				if (addressData.cisloPopisne) {
					address += addressData.cisloPopisne;
					if (addressData.cisloOrientacni) {
						address += "/";
					}
				}
				if (addressData.cisloOrientacni) {
					address += addressData.cisloOrientacni;
				}
				if (addressData.mesto || addressData.mestskaCast || addressData.smerovaciCislo) {
					address += "<br>";
					if (addressData.mesto) {
						address += addressData.mesto;
						if (addressData.mestskaCast) {
							address += " - ";
						}
					}
					if (addressData.mestskaCast) {
						address += addressData.mestskaCast;
					}

					if (addressData.smerovaciCislo) {
						if (addressData.mesto || addressData.mestskaCast) {
							address += ", ";
						}
						address += addressData.smerovaciCislo;
					}
				}
			}
			if (('poverenaObec' in addressData) && addressData.poverenaObec) {
				if (address) {
					address += "<br>";
				}
				address += "Pověřená obec: " + addressData.poverenaObec;
				if (('kodPovereneObce' in addressData) && addressData.kodPovereneObce) {
					address += " (" + addressData.kodPovereneObce + ")";
				}
			}
			if (('poznamka' in addressData) && addressData.poznamka) {
				if (address) {
					address += "<br>";
				}
				address += addressData.poznamka;
			}
		} else {
			address = "Neuvedeno";
		}
		return address;
	}

	/**
	 * @param data
	 * @returns {string}
	 */
	static formatAgendy (data) {
		if (Array.isArray(data)) {

			var result = "";
			if (Array.isArray(data)) {
				result = "<tr><td colspan='2' class='head-row'>" + RegistryDataParser.transKey("agendy") + "</td></tr>";
				if (data.length) {
					data.forEach(function (agenda) {
						result += "<tr class='agenda-row'><td>";
						if (('jmeno' in agenda) && agenda.jmeno) {
							result += agenda.jmeno;
						}
						result += "</td><td>";
						if (('adresa' in agenda) && agenda.adresa) {
							if (typeof agenda.adresa !== 'object') {
								result += agenda.adresa;
							} else {
								result += RegistryDataParser.formatAddress(agenda.adresa);
							}
							result += "<br>";
						}
						if (('kodAgendy' in agenda) && agenda.kodAgendy) {
							result += "Kód: " + agenda.kodAgendy + "<br>";
						}
						if (('poznamka' in agenda) && agenda.poznamka) {
							result += "Poznámka: " + agenda.poznamka;
						}
						result += "</td></tr>";
					});
				} else {
					result += "<tr><td colspan='2'>Žádný záznam</td></tr>";
				}
				return result;
			} else {
				result = "<tr><td>" + RegistryDataParser.transKey("agendy") + "</td><td>" + RegistryDataParser.renderRaw(data) + "</td></tr>";
			}
			return result;
		} else {
			return RegistryDataParser.renderRaw(data);
		}
	}

	/**
	 * 
	 * @param data
	 */
	static formatProvozovny (data) {
		var result = "";
		if ('addressList' in data) {
			result = "<tr><td colspan='2' class='head-row'>" + RegistryDataParser.transKey("provozovny") + "</td></tr>";
			if (data.addressList.length) {
				data.addressList.forEach(function (address) {
					result += "<tr class='address-row'><td></td><td>"
						+ RegistryDataParser.formatAddress(address)
						+ "</td></tr>";
				});
			} else {
				result += "<tr><td colspan='2'>Žádný záznam</td></tr>";
			}
		} else {
			result = "<tr><td>" + RegistryDataParser.transKey("provozovny") + "</td><td>" + RegistryDataParser.renderRaw(data) + "</td></tr>";
		}
		return result;
	}

	/**
	 * 
	 * @param data
	 */
	static formatRO (data) {
		var result = "";
		if (Array.isArray(data)) {
			result = "<tr><td colspan='2' class='head-row'>" + RegistryDataParser.transKey("ridicskeOpravneni") + "</td></tr>";
			if (data.length) {
				data.forEach(function (row) {
					if (('skupina' in row) && ('stav' in row)) {
						var text = RegistryDataParser.transKey(row.stav);
						if (('datumUdeleni' in row) && row.datumUdeleni) {
							text += ", udělen " + RegistryDataParser.formatDate(row.datumUdeleni);
						}
						if (('datumPlatnosti' in row) && row.datumPlatnosti) {
							text += ", platnost " + RegistryDataParser.formatDate(row.datumPlatnosti);
						}
						if (('harmonizacniKod' in row) && row.harmonizacniKod) {
							text += ", harmonizační kód: " + row.harmonizacniKod;
						}
						result += "<tr><td>" + row.skupina + "</td><td>" + text + "</td></tr>";
					}
				});
			} else {
				result += "<tr><td colspan='2'>Žádný záznam</td></tr>";
			}
			return result;
		} else {
			result = "<tr><td>" + RegistryDataParser.transKey("ridicskeOpravneni") + "</td><td>" + RegistryDataParser.renderRaw(data) + "</td></tr>";
		}
		return result;
	}

	/**
	 *
	 * @param data
	 */
	static formatRP (data) {
		var result = "";
		if (Array.isArray(data)) {
			result = "<tr><td colspan='2' class='head-row'>" + RegistryDataParser.transKey("ridicskyPrukaz") + "</td></tr>";
			if (data.length) {
				data.forEach(function (row) {
					if (('cisloRp' in row) && ('stav' in row)) {
						var text = RegistryDataParser.transKey(row.stav);
						if (('datumVydani' in row) && row.datumVydani) {
							text += ", vydán " + RegistryDataParser.formatDate(row.datumVydani);
						}
						if (('datumPlatnosti' in row) && row.datumPlatnosti) {
							text += ", platnost " + RegistryDataParser.formatDate(row.datumPlatnosti);
						}
						if (('vydavajiciUrad' in row) && row.vydavajiciUrad) {
							text += ", vydávající úřad: " + row.vydavajiciUrad;
						}
						result += "<tr><td>" + row.cisloRp + "</td><td>" + text + "</td></tr>";
					}
				});
			} else {
				result += "<tr><td colspan='2'>Žádný záznam</td></tr>";
			}
			return result;
		} else {
			result = "<tr><td>" + RegistryDataParser.transKey("ridicskyPrukaz") + "</td><td>" + RegistryDataParser.renderRaw(data) + "</td></tr>";
		}
		return result;
	}

	/**
	 *
	 * @param data
	 */
	static formatZR (data) {
		var result = "";
		if (Array.isArray(data)) {
			result = "<tr><td colspan='2' class='head-row'>" + RegistryDataParser.transKey("zakazRizeni") + "</td></tr>";
			if (data.length) {
				data.forEach(function (row) {
					if ('skupinyRo' in row) {
						var text = "";
						if (('zakazOd' in row) && row.zakazOd) {
							text += "OD: " + RegistryDataParser.formatDate(row.zakazOd);
						}
						if (('zakazDo' in row) && row.zakazDo) {
							text += " DO: " + RegistryDataParser.formatDate(row.zakazDo);
						}
						result += "<tr><td>" + row.skupinyRo + "</td><td>" + text + "</td></tr>";
					}
				});
			} else {
				result += "<tr><td colspan='2'>Žádný záznam</td></tr>";
			}
			return result;
		} else {
			result = "<tr><td>" + RegistryDataParser.transKey("zakazRizeni") + "</td><td>" + RegistryDataParser.renderRaw(data) + "</td></tr>";
		}
		return result;
	}
	
	/**
	 *
	 * @param data
	 */
	static formatBlokace (data) {
		var result = "";
		if (Array.isArray(data)) {
			result = "<tr><td colspan='2' class='head-row'>" + RegistryDataParser.transKey("blokaceRoDetail") + "</td></tr>";
			if (data.length) {
				data.forEach(function (row) {
					if ('skupinyRo' in row) {
						var text = "";
						if (('blokaceOd' in row) && row.blokaceOd) {
							text += "OD: " + RegistryDataParser.formatDate(row.blokaceOd);
						}
						if (('blokaceDo' in row) && row.blokaceDo) {
							text += " DO: " + RegistryDataParser.formatDate(row.blokaceDo);
						}
						result += "<tr><td>" + row.skupinyRo + "</td><td>" + text + "</td></tr>";
					}
				});
			} else {
				result += "<tr><td colspan='2'>Žádný záznam</td></tr>";
			}
			return result;
		} else {
			result = "<tr><td>" + RegistryDataParser.transKey("zakazRizeni") + "</td><td>" + RegistryDataParser.renderRaw(data) + "</td></tr>";
		}
		return result;
	}

	/**
	 *
	 * @param data
	 */
	static formatHP (data) {
		var result = "";
		if (Array.isArray(data)) {
			result = "<tr><td colspan='2' class='head-row'>" + RegistryDataParser.transKey("historiePrestupku") + "</td></tr>";
			if (data.length) {
				data.forEach(function (row) {
					var key = "";
					if ('klasifikace' in row) {
						key += row.klasifikace;
					}
					if ('typ' in row) {
						key += ": " + row.typ;
					}
					var val = "";
					if (('popis' in row) && row.popis) {
						val += row.popis;
					}
					if (('body' in row) && row.body) {
						val += "<br>Body: " + row.body;
					}
					if (('datumSpachani' in row) && row.datumSpachani) {
						val += ", datum spáchání: " + RegistryDataParser.formatDate(row.datumSpachani);
					}
					if (('datumNabytiPravniMoci' in row) && row.datumNabytiPravniMoci) {
						val += ", datum nabytí právní moci: " + RegistryDataParser.formatDate(row.datumNabytiPravniMoci);
					}
					result += "<tr><td>" + key + "</td><td>" + val + "</td></tr>";
				});
			} else {
				result += "<tr><td colspan='2'>Žádný záznam</td></tr>";
			}
			return result;
		} else {
			result = "<tr><td>" + RegistryDataParser.transKey("historiePrestupku") + "</td><td>" + RegistryDataParser.renderRaw(data) + "</td></tr>";
		}
		return result;
	}
	
	/**
	 * 
	 * @param data
	 * @returns {string}
	 */
	static formatArray (data) {
		var result = "",
			first = true;
		data.forEach(function (value) {
			if (first) {
				first = false;
			} else {
				result += ", ";
			}
			if ((value !== null) && (typeof value !== 'object')) {
				result += value;
			}
		});
		return result;
	}

	/**
	 * 
	 * @param data
	 * @returns {string}
	 */
	static formatCisloPasu (data) {
		var result = "",
			first = true;
		
		if (typeof data === 'object') {
			for (var i in data) {
				if (first) {
					first = false;
				} else {
					result += ", ";
				}
				result += data[i];
			}
		} else {
			result = RegistryDataParser.formatArray(data);
		}
		return result;
	}

	/**
	 * 
	 * @param value
	 * @returns {string|*}
	 */
	static formatDataValue (value) {
		if ((value === true) || (value === "true")) {
			return "Ano";
		} else if ((value === false) || (value === "false")) {
			return "Ne";
		} else if ((value === null) || (value === "null")) {
			return "";
		}
		return value;
	}

	/**
	 * 
	 * @param data
	 * @returns {boolean}
	 */
	static isObjectEmpty(data) {
		for (var key in data) {
			if (data[key]) {
				return false;
			}
		}
		return true;
	}


	//-------------------------------------------------------------------------
	// Rendering methods
	//-------------------------------------------------------------------------

	/**
	 * Render photo (in table)
	 * @param photoData
	 * @returns {string}
	 */
	static renderPhoto (photoData) {
		return "<table class='registry-op-table table-striped'>"+RegistryDataParser.renderPhotoRow(photoData)+"</table>";
	}

	/**
	 * Render photo row
	 * @param photoData
	 * @returns {string}
	 */
	static renderPhotoRow (photoData) {
		return "<tr><td>Fotografie</td><td>"
			+"<img class=\"registry-photo\" src=\"data:image/jpeg;base64, " + photoData + "\" alt=\"photo\">"
			+"</td></tr>";
	}

	/**
	 * Render data as they came - in case the parsing failed
	 * @param data
	 * @returns {string}
	 */
	static renderRaw (data) {
		var html = "<table class=\"registry-data-table table-striped\"><tr><th>Název</th><th>Hodnota</th></tr>"

		for (var property in data) {
			if (property != "_parsed") {
				var value = data[property];
				if ((value !== null) && (!Array.isArray(value) || (value.length > 0))) {
					html += "<tr><td>" + RegistryDataParser.transKey("" + property) + "</td><td>";
					if (Array.isArray(value)) {
						html += RegistryDataParser.formatArray(value);
					} else if ((typeof value === 'object')) {
						html += RegistryDataParser.renderRaw(value);
					} else if (property === "photo") {
						value = "<img src=\"data:image/jpeg;base64, " + value + "\" alt=\"photo\">";
					} else {
						html += value;
					}
				}
				html += "</td></tr>";
			}
		}

		html += "</table>";

		return html;
	}

	/**
	 * 
	 * @param key
	 * @param value
	 * @returns {string}
	 */
	static renderRow (key, value) {
		var result = "",
			defaultRendering = true;
		if (value !== null) {
			var cellAttributes = "";
			if ((key === "adresa") || (key === "trvalyPobyt") || (key === "dorucovaciAdresa") 
				|| (key === "adresaMistaPobytu") || (key === "matkaAdresa")
				|| (key === "otecAdresa") || (key === "adresaPobytu")) {
				value = RegistryDataParser.formatAddress(value);
			} else if (key === "agendy") {
				result = RegistryDataParser.formatAgendy(value);
				defaultRendering = false;
			} else if (key === "provozovny") {
				result = RegistryDataParser.formatProvozovny(value);
				defaultRendering = false;
			} else if (key === "ridicskeOpravneni") {
				result = RegistryDataParser.formatRO(value);
				defaultRendering = false;
			} else if (key === "ridicskyPrukaz") {
				result = RegistryDataParser.formatRP(value);
				defaultRendering = false;
			} else if (key === "zakazRizeni") {
				result = RegistryDataParser.formatZR(value);
				defaultRendering = false;
			} else if (key === "blokaceRoDetail") {
				result = RegistryDataParser.formatBlokace(value);
				defaultRendering = false;
			} else if (key === "historiePrestupku") {
				result = RegistryDataParser.formatHP(value);
				defaultRendering = false;
			} else if (key === "odpovedPdf") {
				defaultRendering = false;
			} else if (key === "casVytvoreni") {
				value = RegistryDataParser.formatDate(value);
			} else if ((key === "cisloPasu") && ((typeof value === 'object') || Array.isArray(value))) {
				value = RegistryDataParser.formatCisloPasu(value);
			} else if ((value === true) || (value === false) || (value === "true") || (value === "false")) {
				value = "<strong>" + RegistryDataParser.transKey(""+value) + "</strong>";
			} else if (Array.isArray(value) && (value.length > 0)) {
				value = RegistryDataParser.formatArray(value);
			} else if (typeof value === 'object') {
				value = RegistryDataParser.renderRaw(value);
			} else if ((key === "photo") || (key === "fotografie")) {
				value = "<img class=\"registry-photo\" src=\"data:image/jpeg;base64, " + value + "\" alt=\"photo\">";
			}
			if (key === "cisloOp") {
				cellAttributes = "class=\"id-card-cell\"";
			}
			if (defaultRendering) {
				result = "<tr><td>" + RegistryDataParser.transKey(key) + "</td><td " + cellAttributes + ">" + value + "</td></tr>";
			}
		}
		return result;
	}

	//-------------------------------------------------------------------------
	// Data processing methods
	//-------------------------------------------------------------------------

	processHeader (group, data) {
		var responseSuccess = false,
			errorMessage = "",
			className = "",
			key = "Chyba";

		this._html += "<div class='parsed-data'><table class=\"registry-data-table parsed table-striped\">"
			+ "<tr><th colspan='2'>" + RegistryDataParser.transKey(group) + "</th></tr>";
		
		if (('statusKod' in data) && ('statusDetail' in data)) {
			key = data.statusKod;
			switch (data.statusKod) {
				case REGISTRY_RESULT_FOUND: //nobreak
				case REGISTRY_RESULT_OK:
					if ((('response' in data) && data.response)
						|| ((group === "isepInsertResponse") && ('isepNewEntityId' in data))
						|| (group === "isepDeleteResponse")) {
						responseSuccess = true;
					} else {
						errorMessage = "Chyba formátu výsledku";
						className = "warning";
					}
					break;
					
				case REGISTRY_RESULT_NOT_FOUND:
					errorMessage = data.statusDetail ? data.statusDetail : "Výsledek nenalezen";
					className = (group === 'patrani') ? "wanted-result-"+data.statusKod : "warning";
					break;

				case REGISTRY_RESULT_NOT_SEARCHED:
					errorMessage = data.statusDetail ? data.statusDetail : "Nedotázán";
					className = (group === 'patrani') ? "wanted-result-"+data.statusKod : "";
					break;
					
				case REGISTRY_RESULT_IN_PROGRESS:
					errorMessage = data.statusDetail;
					className = "warning";
					responseSuccess = true;
					break;

				case REGISTRY_RESULT_ERROR:
					errorMessage = data.statusDetail ? data.statusDetail : "Chyba dotazu";
					className = (group === 'patrani') ? "wanted-result-"+data.statusKod : "error";
					break;
					
				default:
					errorMessage = data.statusDetail ? data.statusDetail : "Neznámý typ odpovědi";
					className = "error";
					break;
			}
		} else {
			errorMessage = "Chyba formátu výsledku";
			className = "warning";
		}
		
		if ( !responseSuccess ) {
			this._html += "<tr class='" + className + "'><td>"
				+ RegistryDataParser.transKey(key)
				+ "</td><td>"
				+ errorMessage
				+ "</td></tr>";
		}
		return responseSuccess;
	}
	
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	/**
	 * Format response from PATROS
	 * @param data
	 * @param person
	 * @returns {string}
	 */
	formatPatrani (data, person) {
		if (this.processHeader("patrani", data)) {
			this._html += "<tr class='wanted-result-"+data.statusKod+"'>"
				+ "<td><strong>"+data.statusKod+"</strong></td><td>"+(data.statusDetail ? data.statusDetail : "")+"</td>"
				+ "</tr>";
			if (('response' in data) && data.response) {
				this.renderPatrmv(data.response);// person ? this.renderPatros(data.response) : this.renderPatrmv(data.response);
			}
		}

		this._html += "</table></div>";
	}

	/**
	 * 
	 * @param data
	 * @returns {string}
	 */
	renderPatrmv (data) {
		if ('vysledekKontroly' in data) {
			this._html += "<tr class='wanted-warning'><td>Výsledek kontroly</td><td>" + data.vysledekKontroly + "</td></tr>";
			delete data.vysledekKontroly;
		}
		if ('varovani' in data) {
			this._html += "<tr class='wanted-warning'><td>Varování</td><td>" + data.varovani.join(", ") + "</td></tr>";
			delete data.varovani;
		}
		if (('fotografie' in data) && data.fotografie) {
			this._html += RegistryDataParser.renderPhotoRow(data.fotografie);
			delete data.fotografie;
		}
		if (('pokyn' in data) && data.pokyn) {
			this._html += "<tr class='wanted-warning'><td>Pokyn</td><td>" + data.pokyn + "</td></tr>";
			delete data.pokyn;
		}
		//TODO vypsat dalsi pole
	}

	/*renderPatros: function (data) {
		var html = "";
		if ('vysledekKontroly' in data) {
			html += "<tr class='warning'><td>Výsledek kontroly</td><td>" + data.vysledekKontroly + "</td></tr>"
		}
		if ('varovani' in data) {
			html += "<tr class='warning'><td>Varování</td><td>" + data.varovani.join(", ") + "</td></tr>"
		}
		return html;
	},*/


	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	formatEopResponse (data) {
		if (this.processHeader("eopResponse", data)) {
			//this._crvExists = true;
			var response = data.response;
			for (var key in response) {
				switch (key) {
					case 'obcanskePrukazy':
						var tmp = response.obcanskePrukazy;
						if ((typeof response.obcanskePrukazy == 'object') && ('obcanskePrukazy' in response.obcanskePrukazy)) {
							tmp = response.obcanskePrukazy.obcanskePrukazy;
						}
						this._html += this.renderIdCards(tmp);
						break;

					case 'fotografie':
						this._html += RegistryDataParser.renderPhoto(response.fotografie);
						break;

					default:
						break;
				}
			}
		}
		this._html += "</table></div>";
	}


	renderIdCards (data) {
		if (Array.isArray(data)) {
			var result = "<table class='registry-op-table table-striped'>",
				today = new Date(),
				dd = String(today.getDate()).padStart(2, '0'),
				mm = String(today.getMonth() + 1).padStart(2, '0'), //January is 0!
				yyyy = today.getFullYear(),
				todayStr = yyyy+"-"+mm+"-"+dd;
			data.forEach(function (idCard) {
				var status = "invalid",
					statusString = "Chybná data";
				if (('platnostDo' in idCard) && ('datumUkonceniPLatnosti' in idCard) && ('status' in idCard))
				{
					if ((idCard.datumUkonceniPLatnosti == null) && (idCard.platnostDo >= todayStr)) {
						status = "valid";
						statusString = "Platnost do: " + RegistryDataParser.formatDate(idCard.platnostDo);
					} else {
						if (idCard.status == "Skončení platnosti OP"
							|| ((idCard.status == "Převzetí OP") && (idCard.platnostDo < todayStr))) {
							status = "expired";
							statusString = idCard.status + " (" + RegistryDataParser.formatDate(idCard.platnostDo) + ")";
						} else {
							status = "invalid";
							statusString = idCard.status + " (zrušeno: " + RegistryDataParser.formatDate(idCard.datumUkonceniPLatnosti) + ")";
						}
					}
					statusString += "<br><i>Platnost: " + RegistryDataParser.formatDate(idCard.platnostOd) + " - "
						+ RegistryDataParser.formatDate(idCard.platnostDo);
					if (idCard.datumVyzvednuti) {
						statusString += ", převzetí: " + RegistryDataParser.formatDate(idCard.datumVyzvednuti);
					}
					statusString += "</i>";
				}

				result += "<tr class='id-card-row st-"+status+"'><td>";
				if ('cisloOp' in idCard) {
					result += idCard.cisloOp;
				}
				result += "</td><td>" + statusString + "</td></tr>";
			});
			result += "</table>";
			return result;
		} else {
			return RegistryDataParser.renderRaw(data);
		}
	}

	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	formatCRVResponse (data) {
		if (this.processHeader("crvResponse", data)) {
			//this._crvExists = true;
			var response = data.response;
			if (('provozovatel' in response)
				&& response.provozovatel
				&& ('typProvozovatele' in response.provozovatel)) {
				var provozovatel = response.provozovatel;
	
	
				//-------------------------
				//Vehicle info
				this._html += "<tr><td colspan='2'><strong>" + RegistryDataParser.transKey('vehicleInfo') + "</strong></td></tr>";
				
				this._html += "<tr><td>" + RegistryDataParser.transKey('rz') + "</td><td>" 
					+ response.rz + "</td></tr>";
				this._html += "<tr><td>" + RegistryDataParser.transKey('vin') + "</td><td>" 
					+ response.vin + "</td></tr>";
				this._html += "<tr><td>" + RegistryDataParser.transKey('tovarniZnacka') + "</td><td>" 
					+ response.tovarniZnacka + "</td></tr>";
				this._html += "<tr><td>" + RegistryDataParser.transKey('barva') + "</td><td>" 
					+ response.barva + "</td></tr>";
				this._html += "<tr><td>" + RegistryDataParser.transKey('cisloOrvCast1') + "</td><td>" 
					+ response.cisloOrvCast1 + "</td></tr>";
				this._html += "<tr><td>" + RegistryDataParser.transKey('cisloOrvCast2') + "</td><td>" 
					+ response.cisloOrvCast2 + "</td></tr>";
				this._html += "<tr><td>" + RegistryDataParser.transKey('status') + "</td><td>" 
					+ response.status + "</td></tr>";

				//Operator info
				this._html += "<tr><td colspan='2'><strong>" 
					+ RegistryDataParser.transKey('provozovatelInfo')
					+ " (" + RegistryDataParser.transKey(provozovatel.typProvozovatele) + ")"
					+ "</strong></td></tr>";

				switch (provozovatel.typProvozovatele) {
					case "EKONOMICKY_SUBJEKT":
						this._html += "<tr><td>" + RegistryDataParser.transKey('obchodniNazevSpolecnosti') + "</td><td>" 
							+ provozovatel.obchodniNazevSpolecnosti + "</td></tr>";
						this._html += "<tr><td>" + RegistryDataParser.transKey('ico') + "</td><td>" 
							+ provozovatel.ico + "</td></tr>";
						this._html += "<tr><td>" + RegistryDataParser.transKey('companyAddress') + "</td><td>" 
							+ RegistryDataParser.formatAddress(provozovatel.adresa) + "</td></tr>";
						if (provozovatel.adresa) {
							this._html += "<tr><td>" + RegistryDataParser.transKey('authority') + "</td><td>"
								+ provozovatel.adresa.poverenaObec
								+ " (kód: " + provozovatel.adresa.kodPovereneObce + ")" + "</td></tr>";
						}
						break;
	
					case "OBYVATEL":
						this._html += "<tr><td>" + RegistryDataParser.transKey('fullName') + "</td><td>"
							+ provozovatel.prijmeni + " " + provozovatel.jmeno + "</td></tr>";
						if (provozovatel.rodnePrijmeni != null) {
							this._html += "<tr><td>" + RegistryDataParser.transKey('rodnePrijmeni') + "</td><td>"
								+ provozovatel.rodnePrijmeni + "</td></tr>";
						}
						this._html += "<tr><td>" + RegistryDataParser.transKey('birthDate') + "</td><td>"
							+ RegistryDataParser.formatDate(provozovatel.datumNarozeni) + "</td></tr>";
						this._html += "<tr><td>" + RegistryDataParser.transKey('rodneCislo') + "</td><td>"
							+ provozovatel.rodneCislo + "</td></tr>";
						this._html += "<tr><td>" + RegistryDataParser.transKey('personAddress') + "</td><td>"
							+ RegistryDataParser.formatAddress(provozovatel.adresa) + "</td></tr>";
						if (provozovatel.adresa) {
							this._html += "<tr><td>" + RegistryDataParser.transKey('authority') + "</td><td>"
								+ provozovatel.adresa.poverenaObec
								+ " (kód: " + provozovatel.adresa.kodPovereneObce + ")" + "</td></tr>";
						}
						break;
	
					case "CIZI_OSOBA":
						var name = null,
							key = null;
						if (provozovatel.prijmeni != null) {
							name = provozovatel.prijmeni;
							if (provozovatel.jmeno != null) {
								name += " " + provozovatel.jmeno;
								key = "fullName";
							} else {
								key = "surname";
							}
						} else if (provozovatel.jmeno != null) {
							name = provozovatel.jmeno;
							key = "name";
						}
						if (name != null) {
							this._html += "<tr><td>" + RegistryDataParser.transKey(key) + "</td><td>"
								+ name + "</td></tr>";
						}
						if (provozovatel.rodnePrijmeni != null) {
							this._html += "<tr><td>" + RegistryDataParser.transKey('rodnePrijmeni') + "</td><td>"
								+ provozovatel.rodnePrijmeni + "</td></tr>";
						}
						if (provozovatel.datumNarozeni != null) {
							this._html += "<tr><td>" + RegistryDataParser.transKey('birthDate') + "</td><td>"
								+ RegistryDataParser.formatDate(provozovatel.datumNarozeni) + "</td></tr>";
						}
						if (provozovatel.rodneCislo != null) {
							this._html += "<tr><td>" + RegistryDataParser.transKey('rodneCislo') + "</td><td>"
								+ provozovatel.rodneCislo + "</td></tr>";
						}
						if (provozovatel.adresa != null) {
							this._html += "<tr><td>" + RegistryDataParser.transKey('personAddress') + "</td><td>"
								+ RegistryDataParser.formatAddress(provozovatel.adresa) + "</td></tr>";
						}
						if (provozovatel.obchodniNazevSpolecnosti != null) {
							this._html += "<tr><td>" + RegistryDataParser.transKey('obchodniNazevSpolecnosti') + "</td><td>"
								+ provozovatel.obchodniNazevSpolecnosti + "</td></tr>";
						}
						if (provozovatel.ico != null) {
							this._html += "<tr><td>" + RegistryDataParser.transKey('ico') + "</td><td>"
								+ provozovatel.ico + "</td></tr>";
						}
						break;
	
					default:
						break;
				}
	
				//-------------------------
	
				
				//Nenalezen / chyba ...
			} else {
				
			}
		}
		this._html += "</table></div>";
	}

	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	/**
	 * 
	 * @param person
	 * @returns {string}
	 */
	static formatPersonData(person) {
		var result = "<tr><td>" + RegistryDataParser.transKey('jmeno') + "</td><td>"
			+ person.jmeno + "</td></tr>"; 
			
		if (person.datumNarozeni != null)
		{
			result += "<tr><td>" + RegistryDataParser.transKey('birthDate') + "</td><td>"
				+ person.datumNarozeni + "</td></tr>";
		}
		if (person.pohlavi != null)
		{
			result += "<tr><td>" + RegistryDataParser.transKey('pohlavi') + "</td><td>"
				+ person.pohlavi + "</td></tr>";
		}
		if (person.adresa != null)
		{
			result += "<tr><td>" + RegistryDataParser.transKey('adresa') + "</td><td>"
				+ person.adresa + "</td></tr>";
		}
		return result;
	}

	/**
	 * 
	 * @param data
	 */
	formatEucarisResponse(data) {
		if (this.processHeader("eucarisResponse", data)) {
			var response = data.response;

			//Vehicle info
			this._html += "<tr><td colspan='2'><strong>" + RegistryDataParser.transKey('vehicleInfo') + "</strong></td></tr>";
			
			this._html += "<tr><td>" + RegistryDataParser.transKey('rz') + "</td><td>"
				+ response.rz + "</td></tr>";
			
			if (('alternativniRz' in response) && (response.alternativniRz != null))
			{
				this._html += "<tr><td>" + RegistryDataParser.transKey('altRz') + "</td><td>"
					+ response.alternativniRz + "</td></tr>";
			}
			this._html += "<tr><td>" + RegistryDataParser.transKey('tovarniZnacka') + "</td><td>"
				+ response.tovarniZnacka + "</td></tr>";
			this._html += "<tr><td>" + RegistryDataParser.transKey('obchodniZnacka') + "</td><td>"
				+ response.obchodniZnacka + "</td></tr>";

			if (('provozovatel' in response)
				&& (response.provozovatel != null)
				&& ('jmeno' in response.provozovatel)
				&& (response.provozovatel.jmeno != null))
			{
				//Operator info
				this._html += "<tr><td colspan='2'><strong>" + RegistryDataParser.transKey('provozovatelInfo') + "</strong></td></tr>";
				this._html += RegistryDataParser.formatPersonData(response.provozovatel);
			}
			if (('majitel' in response)
				&& (response.majitel != null)
				&& ('jmeno' in response.majitel)
				&& (response.majitel.jmeno != null))
			{
				//Owner info
				this._html += "<tr><td colspan='2'><strong>" + RegistryDataParser.transKey('ownerInfo') + "</strong></td></tr>";
				this._html += RegistryDataParser.formatPersonData(response.majitel);
			}
		}
		this._html += "</table></div>";
	}

	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------
	
	formatRobResponse (data) {
		if (this.processHeader("robResponse", data)) {
			var response = data.response;
			for (var rowKey in response) {
				this._html += RegistryDataParser.renderRow(rowKey, response[rowKey]);
			}
		}
		this._html += "</table></div>";
	}
	
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	formatRosResponse (data) {
		if (this.processHeader("rosResponse", data)) {
			var response = data.response;
			for (var rowKey in response) {
				this._html += RegistryDataParser.renderRow(rowKey, response[rowKey]);
			}
		}
		this._html += "</table></div>";
	}
	
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	formatCrrResponse (data) {
		if (this.processHeader("crrResponse", data)) {
			var response = data.response;
			for (var rowKey in response) {
				this._html += RegistryDataParser.renderRow(rowKey, response[rowKey]);
			}
		}
		this._html += "</table></div>";
	}
	
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	formatAiseoResponse (data) {
		if (this.processHeader("aiseoResponse", data)) {
			var response = data.response;
			for (var rowKey in response) {
				this._html += RegistryDataParser.renderRow(rowKey, response[rowKey]);
			}
		}
		this._html += "</table></div>";
	}
	
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	formatAiscResponse (data) {
		if (this.processHeader("aiscResponse", data)) {
			var response = data.response;
			for (var rowKey in response) {
				this._html += RegistryDataParser.renderRow(rowKey, response[rowKey]);
			}
		}
		this._html += "</table></div>";
	}
	
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	/*formatPrestupekBlok (key, data) {
		if (Array.isArray(data) && data.length > 0) {
			
		} else if ((typeof data == "object") && (!RegistryDataParser.isObjectEmpty(data))) {
			
		}
	}
	
	formatPrestupek (data) {
		if (typeof data == "object") {
			for (var key in data) {
				if (data[key]) {
					this.formatPrestupekBlok(key, data[key]);
				}
			}
		}
	}
	
	formatPrestupky (data) {
		if (data && Array.isArray(data) && data.length > 0) {
			this._html += "<tr><td colspan='2'><strong>"
				+ RegistryDataParser.transKey('prestupky')
				+ "</strong></td></tr>";
			for (var i in data) {
				this.formatPrestupek(data[i]);
			}
		}
	}*/
	
	formatIsepReadResponse (data) {
		var filename = null;
		var fileLink = null;
		if (this.processHeader("isepSelectResponse", data)) {
			var response = data.response;
			for (var rowKey in response) {
				switch (rowKey) {
					case "prestupky":
						//this.formatPrestupky(response[rowKey]);
						break;
					case "seznamKvalifikaci": //nobreak;
					case "outputFile":
						filename = response.outputFile;
						//Do not print
						break;
					case "outputFileId":
						//Do not print
						break;
					case "outputFileLink":
						fileLink = response.outputFileLink;
						//Do not print
						break;
					default:
						this._html += RegistryDataParser.renderRow(rowKey, response[rowKey]);
						break;
				}
			}
		}
		this._html += "</table></div>";
		
		if (filename) {
			if (fileLink) {
				filename = '<span class="display-document-popup tooltips" data-src="'+ fileLink 
					+'" title="Zobrazit soubor">'+filename+'</span>';
			}
			this._html += "<div><strong>Kompletní report uložen do souboru " + filename + "</strong></div>";
		}
	}
	
	formatIsepInsertResponse (data) {
		if (this.processHeader("isepInsertResponse", data)) {
			this._html += RegistryDataParser.renderRow('statusDetail', data.statusDetail);
			if ('isepNewEntityId' in data)
			{
				this._html += RegistryDataParser.renderRow('isepNewEntityId', data.isepNewEntityId);
			}
		}
		this._html += "</table></div>";
	}

	formatIsepDeleteResponse (data) {
		if (this.processHeader("isepDeleteResponse", data)) {
			this._html += RegistryDataParser.renderRow('statusDetail', data.statusDetail);
			/*if ('isepNewEntityId' in data)
			{
				this._html += RegistryDataParser.renderRow('isepNewEntityId', data.isepNewEntityId);
			}*/
		}
		this._html += "</table></div>";
	}

	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------

	formatIsrtResponse (data) {
		var filename = null;
		var fileLink = null;
		if (this.processHeader("isrtSelectResponse", data)) {
			var response = data.response;
			for (var rowKey in response) {
				switch (rowKey) {
					case "outputFile":
						filename = response.outputFile;
						//Do not print
						break;
					case "outputFileId":
						//Do not print
						break;
					case "outputFileLink":
						fileLink = response.outputFileLink;
						//Do not print
						break;
					case "data":
						this._html += "<tr><td>Soubor</td><td>" + ('outputFile' in response ? response.outputFile : "") + "</td></tr>";
						break;
					default:
						this._html += RegistryDataParser.renderRow(rowKey, response[rowKey]);
						break;
				}
			}
		}
		this._html += "</table></div>";

		if (filename) {
			if (fileLink) {
				filename = '<span class="display-document-popup tooltips" data-src="'+ fileLink
					+'" title="Zobrazit soubor">'+filename+'</span>';
			}
			this._html += "<div><strong>Výpis uložen do souboru: " + filename + "</strong></div>";
		} else {
			this._html += "<div><strong>Požadavek byl zařazen ke zpracování, o výsledku budete informováni.</strong></div>";
		}
	}
	
	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------
	
	printLogRows (data) {
		this._html += "<td class='nopadding'>";
		
		if ('columns' in data && 'rows' in data) {
			var i, j;
			this._html += "<table><tr>";
			for (i in data['columns']) {
				this._html += "<th>" + RegistryDataParser.transKey(data['columns'][i]) + "</th>";
			}
			this._html += "</tr>";

			for (i in data['rows']) {
				this._html += "<tr>";
				for (var j in data['rows'][i]) {
					switch (j) {
						case "personDateOfBirth":
						case "validity":
						case "queryTime":
							this._html += "<td>" + RegistryDataParser.formatDate(data['rows'][i][j]) + "</td>";
							break;

						default:
							this._html += "<td>" + data['rows'][i][j] + "</td>";
							break;
					}
				}
				this._html += "</tr>";
			}
			
			this._html += "</table>";
		}
		
		this._html += "</td>";
	}
	
	formatLogResponse (data) {
		this._html += "<div class='parsed-data'><table class=\"registry-data-table parsed table-striped registry-log-table\">";

		if (('logResponse' in data) && Array.isArray(data.logResponse) && (data.logResponse.length > 0)) {
			
			var response = data.logResponse;
			for (var i in response) {
				var row = response[i],
					key;
				
				//First row - print header
				if (i == 0) {
					this._html += "<tr>";
					for (key in row) {
						if (key != "uuid" && key != "columns" && key != "rows") {
							this._html += "<th>" + RegistryDataParser.transKey(key) + "</th>";
						}
					}
					this._html += "<th>Data</th>";
					this._html += "</tr>";
				}
				
				if ("uuid" in row) {
					this._html += "<tr id='" + row['uuid'] + "'>";
				} else {
					this._html += "<tr>";
				}
				for (key in row) {
					switch (key) {
						case "uuid":
						case "columns":
						case "rows":
							break;

						default:
							this._html += "<td>"+ RegistryDataParser.formatDataValue(row[key]) +"</td>";
							break;
					}
				}
				
				this.printLogRows(row);
				
				this._html += "</tr>";
			}
		}
		else {
			this._html += "<tr><th>Log</th></tr>";
			this._html += "<tr><td>Nenalezeny žádné záznamy</td></tr>";
		}
		this._html += "</table></div>";
	}

	//-------------------------------------------------------------------------
	//-------------------------------------------------------------------------


};

module.exports = RegistryDataParser;
